import * as React from 'react';
import './Input.scss';

interface IInputProps {
  label?: string;
  placeholder?: string;
  value: string;
  disabled?: boolean;
  required?: boolean;
  invalid?: boolean;
  invalidMessage?: string;
  instructions?: string;
  className?: string;
  type?: string;
  maxLength?: number;
  onChange(value: string): void;
  onKeyDown?(event: React.KeyboardEvent): void;
  autoComplete?: any;
  name?: any;
}

export function Input(props: IInputProps) {
  const className = `rp-input ${props.invalid ? 'invalid' : ''} ${
    props.disabled ? 'disabled' : ''
  }  ${props.className ? props.className : ''}`;
  return (
    <div className={className}>
      <label>
        {props.label}
        {props.required && <span className="required">*</span>}
      </label>
      <input
        value={props.value}
        placeholder={props.placeholder}
        onChange={event => props.onChange(event.target.value)}
        disabled={props.disabled}
        type={props.type ? props.type : 'text'}
        onKeyDown={props.onKeyDown}
        maxLength={props.maxLength}
        {...(props.name && { name: props.name })}
        {...(props.autoComplete && { autoComplete: props.autoComplete })}
      />
      {!props.invalid && !props.instructions && (
        <div className="rp-input--bottom-space" />
      )}
      {props.invalid && (
        <div className="rp-input--message">{props.invalidMessage}</div>
      )}
      {props.instructions && (
        <div className="rp-input--instructions">{props.instructions}</div>
      )}
    </div>
  );
}
